/**
 * Je li greška pad LIJENOG UČITAVANJA modula, a ne pad koda?
 *
 * Sučelja se učitavaju zasebno (`App.tsx`), pa svaki ulazak na rutu koja još nije
 * preuzeta ovisi o mreži — i to o mreži u trenutku tapa, ne o onoj pri otvaranju
 * aplikacije. Padne li taj dohvat (prekinut wifi, 401 s brane pred statikom,
 * chunk kojeg nakon deploya na disku više nema), React dobiva odbijeno obećanje
 * iz `lazy()` i ekran ostaje prazan.
 *
 * Razlika je bitna zato što se te dvije greške različito RJEŠAVAJU: nedostupan
 * modul se popravlja osvježavanjem (novi `index.html` nosi nove hasheve), a pad
 * komponente osvježavanjem najčešće ne. Zato ih poruka razlikuje.
 *
 * Poruke se razlikuju po preglednicima, pa se gleda više oblika; nijedan
 * preglednik ne daje strojno čitljivu oznaku (Vite je nema, a `ChunkLoadError`
 * dolazi iz webpacka — ostaje i on, jer alat se zna promijeniti).
 */
const OBRASCI = [
  // Chrome/Edge, Firefox, Safari (redom).
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  // Stariji oblik iste stvari + webpack.
  'failed to load module script',
  'chunkloaderror',
  'loading chunk',
  'dynamically imported module',
]

export function jeGreskaUcitavanjaModula(greska: unknown): boolean {
  if (!greska) return false

  const ime = greska instanceof Error ? greska.name : ''
  if (ime === 'ChunkLoadError') return true

  const poruka = (greska instanceof Error ? greska.message : String(greska)).toLowerCase()

  return OBRASCI.some((obrazac) => poruka.includes(obrazac))
}
